module.exports = __webpack_public_path__ + "static/media/intro_img.ba5a91d2.png";